module.exports = __webpack_public_path__ + "img/page-box-1.dbda7db.jpg";